import React, { lazy } from 'react'
import Loadable from './../components/loader/Loadable'
import AuthenticationLayout from '../layouts/Authentication'
import PageInfo from '../containers/error/PageInfo'

const Signin = Loadable(lazy(() => import('./../containers/account/signin/SigninIndex')))
const PageNotFound = Loadable(lazy(() => import('./../containers/error/PageNotFound')))
// const StoreRegister = Loadable(lazy(() => import('./../containers/store/register/StoreRegister')))

const AuthenticationRoutes = {
  path: '/',
  element: <AuthenticationLayout />,
  children: [
    {
      path: '/account/signin',
      element: <Signin />,
    },
    {
      path: '/account/unverified',
      element: <PageInfo message="your_account_is_unverified" />,
    },
    // {
    //   path: '/store/register',
    //   element: <StoreRegister />,
    // },
    {
      path: '/store/account-request',
      element: <PageInfo message="your_account_is_on_review" />,
    },
    {
      path: '/store/account-rejected',
      element: <PageInfo message="your_account_request_is_rejected" />,
    },
    {
      path: '/store/account-deactivated',
      element: <PageInfo message="your_account_is_deactivated" />,
    },
    {
      path: '/store/account-verified',
      element: <PageInfo source="verify" message="your_account_has_been_verified" />,
    },
    {
      path: '*',
      element: <PageNotFound />,
    },
  ],
}

export default AuthenticationRoutes
